// extracted by mini-css-extract-plugin
module.exports = {"disabled":"CommonButton_disabled__3b_OB"};